// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Qfei","title":"styles_title__j4P7p"};